import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import fetchActiveMachineList from '@custom/rtk-apis/activeMachine/activeMachineList';
import { ActiveMachineListState } from '@custom/Utils/constants/interfaces';

// Initial state for the slice
const initialState: ActiveMachineListState = {
  data: [],
  status: "",
  loading: false,
  error: null,
  total: 0,
  message: null,
};

const activeMachineListSlice = createSlice({
  name: 'activeMachineList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Handle the different states of the async thunk (pending, fulfilled, rejected)
    builder
      .addCase(fetchActiveMachineList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveMachineList.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload.status;
        state.data = action.payload.result.list; // Set the list from the response
        state.total = action.payload.result.count || 0; // Assuming total is in the response
        state.message = action.payload.msg; // Set the message from the response
      })
      .addCase(fetchActiveMachineList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the reducer to be used in the store
export default activeMachineListSlice.reducer;
